import Vue from 'vue'
import axios from 'axios'

export default {
    state: {
        retrievedData: false,
        groupChatrooms: []
    },

    actions: {
        'groupChatsModel/fetchGroupChats': function (context, data, callback) {
            axios.get('/api/groupChatrooms').then(
                (response) => {
                    context.commit('groupChatsModel/setGroupChatrooms', response.data);

                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                }
            )
        }
    },

    mutations: {
        'groupChatsModel/setGroupChatrooms': function (state, data) {
            state.retrievedData = true;
            state.groupChatrooms = data;
        },

        'groupChatsModel/clearReadMessages'(state, data){
            state.groupChatrooms.forEach(function (chatroom) {
                if (chatroom.id === data.chatId) {
                    Vue.set(chatroom, 'unreadMessages', 0);
                }
            });
        }
    }

}


// WEBPACK FOOTER //
// ./src/ChatRoom/GroupChatsModel.js